module.exports = __webpack_public_path__ + "img/upgrade-plan-inactive.ad6ab4b4.svg";